var n = /* @__PURE__ */ ((t) => (t.DateSelector = "DateSelector", t.MonthSelector = "MonthSelector", t.DateRangePicker = "DateRangePicker", t.MonthRangePicker = "MonthRangePicker", t))(n || {}), e = /* @__PURE__ */ ((t) => (t.StartDate = "startDate", t.EndDate = "endDate", t))(e || {});
const _ = 6;
var o = /* @__PURE__ */ ((t) => (t.TODAY = "today", t.LAST_WEEK = "last_week", t.LAST_MONTH = "last_month", t.CURRENT_MONTH = "current_month", t.LAST_THREE_MONTHS = "last_three_months", t.LAST_TWELVE_MONTHS = "last_twelve_months", t.PERIOD = "period", t.CURRENT_YEAR = "current_year", t.LAST_YEAR = "last_year", t))(o || {});
const r = {
  today: "Today",
  last_week: "Last week",
  last_month: "Last month",
  current_month: "Current month",
  last_three_months: "Last 3 months",
  last_twelve_months: "Last 12 months",
  period: "Period",
  current_year: "Current year",
  last_year: "Last year"
};
export {
  _ as DEFAULT_PERIOD,
  o as DateCriteria,
  e as DatePickerInputName,
  n as DatePickerType,
  r as defaultDateCriteriaTranslation
};
